import { showGreeting } from "./Greetings";

const date = new Date();
const time = document.querySelector(".time");
const dateToday = document.querySelector(".date");
let timeOfDay;
let currentDate;

function showTime() {
  const date = new Date();
  const options = { hour12: false };
  const currentTime = date.toLocaleTimeString("ru-Ru"); //"en - US", { hour12: false });
  time.textContent = currentTime;
  showDate();
  showGreeting();
  setTimeout(showTime, 1000);
}
showTime();
function showDate(lang = "en") {
  const date = new Date();
  const options = {
    weekday: "long",
    month: "long",
    day: "numeric",
  };
  if (lang == "en") {
    currentDate = date.toLocaleDateString("en-Us", options);
  } else if (lang == "ru") {
    currentDate = date.toLocaleDateString("ru-Ru", options);
  } else {
    currentDate = date.toLocaleDateString("de-De", options);
  }
  dateToday.textContent = currentDate;
}
function getTimeOfDay() {
  const date = new Date();
  const hours = date.getHours();
  if (hours >= 6 && hours < 12) {
    return (timeOfDay = "morning");
  } else if (hours >= 12 && hours < 18) {
    return (timeOfDay = "afternoon");
  } else if (hours >= 18 && hours < 24) {
    return (timeOfDay = "evening");
  } else {
    return (timeOfDay = "night");
  }
}
export { showTime, showDate, getTimeOfDay, date, time, dateToday };
